import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
var Validator = require('share/components/hoc/Izenda.Validator');
var Input = Validator()(require('share/components/controls/Izenda.Input'));
var EventsUtils = require('EventUtils');
var localizer = require('share/localization/Izenda.Localizer');

export default class ImageDimensions extends Component {
  state = {
    imageDimension: this.props.value,
    oldImageDimension: this.props.value
  };

  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func
  };

  static defaultProps = {
    value: {
      imageWidth: 1,
      imageHeight: 1,
      isConstrainProportions: true
    }
  };


  componentWillReceiveProps(nextProps: any) {
    this.setState({ imageDimension: nextProps.value });
  }

  // save Dimension Value in Props
  handleDimensionValue = (keyType: any) => {
    var imageDimension = this.state.imageDimension;

    this.setState({ oldImageDimension: imageDimension }, function() {
      this.props.onChange && this.props.onChange({ value: imageDimension }, { keyChange: keyType });
    });
  };

  handleChangeIsConstrainValue = (e: any) => {
    this.setState(
      prevState => ({
        imageDimension: {
          ...prevState.imageDimension,
          isConstrainProportions: !this.state.imageDimension.isConstrainProportions
        }
      }),
      function() {
        this.handleDimensionValue('isConstrainProportions');
      }
    );
  };

  handleChangeWidthValue = value => {
    this.setState(prevState => ({
      imageDimension: {
        ...prevState.imageDimension,
        imageWidth: value
      }
    }));
  };

  handleChangeHeightValue = value => {
    this.setState(prevState => ({
      imageDimension: {
        ...prevState.imageDimension,
        imageHeight: value
      }
    }));
  };

  handleWidthEnter = (e: any) => {
    if (e.key === 'Enter') {
      this.handleDimensionValue('imagewidth');
    }
  };

  handleHeightEnter = (e: any) => {
    if (e.key === 'Enter') {
      this.handleDimensionValue('imageHeight');
    }
  };

  handleWidthBlur = (e: any) => {
    var oldDimension = this.getUpdateDimension(this.state.oldImageDimension);
    var oldWidth = oldDimension.imageWidth;

    var imageDimension = this.getUpdateDimension(this.state.imageDimension);
    var width = imageDimension.imageWidth;
    var height = imageDimension.imageHeight;

    if (imageDimension.isConstrainProportions) {
      height = Math.round((parseInt(width) / oldWidth) * height);
    }

    this.setState(
      prevState => ({
        imageDimension: {
          ...prevState.imageDimension,
          imageWidth: width,
          imageHeight: isNaN(height) ? imageDimension.imageHeight : height
        }
      }),
      function() {
        this.handleDimensionValue('imageWidth');
      }
    );
  };

  handleHeightBlur = (e: any) => {
    var oldDimension = this.getUpdateDimension(this.state.oldImageDimension);
    var oldHeight = oldDimension.imageHeight;

    var imageDimension = this.getUpdateDimension(this.state.imageDimension);
    var width = imageDimension.imageWidth;
    var height = imageDimension.imageHeight;

    if (imageDimension.isConstrainProportions) {
      width = Math.round((parseInt(height) / oldHeight) * width);
    }

    this.setState(
      prevState => ({
        imageDimension: {
          ...prevState.imageDimension,
          imageHeight: height,
          imageWidth: isNaN(width) ? imageDimension.imageWidth : width
        }
      }),
      function() {
        this.handleDimensionValue('imageHeight');
      }
    );
  };

  getUpdateDimension(dimension) {
    var oldWidth = dimension.imageWidth != '' ? dimension.imageWidth : 1;
    var oldHeight = dimension.imageHeight != '' ? dimension.imageHeight : 1;

    var obj = {
      imageWidth: oldWidth,
      imageHeight: oldHeight,
      isConstrainProportions: dimension.isConstrainProportions
    };

    return obj;
  }

  render() {
    var notifyChange = EventsUtils.notifyChange;

    return (
      <GridLayout>
        <GridLayout.FullRow>
          <GridLayout.Col cols={5} className='u_noPaddingRight'>
            <Input
              ref='input'
              className='form-control'
              value={this.state.imageDimension.imageWidth}
              onChange={notifyChange(this.handleChangeWidthValue, EventsUtils.INPUT)}
              onBlur={this.handleWidthBlur}
              onKeyDown={this.handleWidthEnter}
            />
          </GridLayout.Col>
          <GridLayout.Col cols={2} className='u_noPadding divider-arrow'>
            <span>X</span>
          </GridLayout.Col>
          <GridLayout.Col cols={5} className='u_noPaddingLeft'>
            <Input
              ref='input'
              className='form-control'
              value={this.state.imageDimension.imageHeight}
              onChange={notifyChange(this.handleChangeHeightValue, EventsUtils.INPUT)}
              onBlur={this.handleHeightBlur}
              onKeyDown={this.handleHeightEnter}
            />
          </GridLayout.Col>
        </GridLayout.FullRow>
        <GridLayout.FullRow>
          <GridLayout.Col cols={12} className='u_noPadding image-constraint'>
            <label className='image-constraint-checkbox'>
              <Input
                className='izenda-CustomCheckBox'
                type='checkbox'
                value={this.state.imageDimension.isConstrainProportions}
                onChange={this.handleChangeIsConstrainValue}
                checked={this.state.imageDimension.isConstrainProportions}
              />
              {localizer.getText('FORMAT_PROPERTIES_LABEL_IS_CONSTRIN_PROPORTIONS')}
            </label>
          </GridLayout.Col>
        </GridLayout.FullRow>
      </GridLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.ImageDimensions.jsx